var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 1200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #bfeaea;\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n\n      .cls-2, .cls-3, .cls-4 {\n        stroke: #00a9a9;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 30px;\n      }\n\n      .cls-3 {\n        fill: none;\n      }\n\n      .cls-4 {\n        fill: #40bfbf;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 600,
    cy: 600.18,
    r: 557.49
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 282.38,
    y: 323.84,
    width: 635.23,
    height: 145.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M344.27,323.74c0-31.03,25.16-56.19,56.19-56.19s56.19,25.16,56.19,56.19-25.16,56.19-56.19,56.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M537.51,323.74c0-31.03,25.16-56.19,56.19-56.19s56.19,25.16,56.19,56.19-25.16,56.19-56.19,56.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M730.76,323.74c0-31.03,25.16-56.19,56.19-56.19s56.19,25.16,56.19,56.19-25.16,56.19-56.19,56.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M917.62,469.74v373.99c0,49.1-40.22,88.72-89.31,88.72h-457.2c-49.09,0-88.72-39.62-88.72-88.72v-373.99h635.23Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 282.38,
    y: 469.74,
    width: 211.74,
    height: 231.36
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 494.13,
    y: 469.74,
    width: 211.74,
    height: 231.36
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 705.87,
    y: 469.74,
    width: 211.74,
    height: 231.36
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "282.38 701.09 494.13 701.09 494.13 932.45"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 494.13,
    y: 701.09,
    width: 211.74,
    height: 231.36
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "705.87 932.45 705.87 701.09 917.62 701.09"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg4);
export default __webpack_public_path__ + "static/media/4.a8062da8952f2fbfe24035ebe9f64f55.svg";
export { ForwardRef as ReactComponent };